module.exports = __webpack_public_path__ + "static/media/upload_file.50ad8dac.svg";